import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { InfoBody } from '../../model/info_body';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

  body : InfoBody = new InfoBody;

  constructor(private element : ElementRef, private modalService : ModalService) {
    this.body.list_content = [];
   }

  ngOnInit() {
    console.log(this.body);
  }

  show(body : InfoBody = new InfoBody){

    this.body = { 
      current_icon : "./assets/img/modal_v2/e-info.png",
      text_align: "text-center",
      list_space: "mb-1",
      list_content: [], ...body 
    };
    this.element.nativeElement.style.visibility = "visible";
  }

  hide(){
    this.element.nativeElement.style.visibility = "hidden";
    if (this.body.onSecondaryAction) this.body.onSecondaryAction();
  }

  accept(){
    this.element.nativeElement.style.visibility = "hidden";
    if(this.body.onMainAction) this.body.onMainAction();
  }

  link(){
    this.element.nativeElement.style.visibility = "hidden";
    if(this.body.onLinkAction) this.body.onLinkAction();
  }
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/modals/info/info.component.ts